import { Components, Theme } from '@mui/material/styles';

export const buildMuiSliderComponent = (): Components<Omit<Theme, 'components'>>['MuiSlider'] => ({
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      width: '100%',
      padding: '10px 0',
      '& .MuiSlider-track': {
        display: 'none',
      },
      '& .MuiSlider-rail': {
        height: '18px',
        padding: ownerState.marks ? '0 12px' : '0 9px',
        marginLeft: ownerState.marks ? '0' : '3px',
        background: theme.palette.primary[30],
      },
      '& .MuiSlider-mark': {
        height: '12px',
        width: '12px',
        transform: 'translate(-50%, -50%)',
        borderRadius: '50%',
        marginLeft: '12px',
        color: 'white',
      },
      '& .MuiSlider-markLabel': {
        marginLeft: '12px',
        color: theme.palette.text.primary,
      },
      '& .MuiSlider-thumb': {
        marginLeft: '12px',
        width: '18px',
        height: '18px',

        background: theme.palette.secondary.main,
        boxShadow: 'none !important',
      },
    }),
    sizeSmall: {
      '& .MuiSlider-thumb': {
        width: '12px',
        height: '12px',
      },
      '& .MuiSlider-mark': {
        height: '6px',
        width: '6px',
      },
      '& .MuiSlider-rail': {
        height: '12px',
      },
    },
  },
  defaultProps: {},
});
